export const tableFiltersTrackers = {
  actions: {
    changeStatusFilter: 'Alterou o filtro de status',
    changeTabFilter: 'Alterou a Tab',
    rowClick: 'Clicou em uma linha da tabela',
    seeAll: 'Clicou em ver tudo',
  },
}
